module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-7-003d51cfcb0faf6b77fecf06b80bcb19.jpg";